import { Snapshots } from 'roosterjs-editor-types';
import { Undo as RoosterUndo, UndoSnapshotsService } from 'roosterjs-editor-core';
import { mutatorAction } from 'satcheljs';
import {
    addSnapshot,
    canMoveCurrentSnapshot,
    moveCurrentSnapsnot,
    clearProceedingSnapshots,
} from 'roosterjs-editor-dom';
import EditorViewState from '../store/schema/EditorViewState';
import initializeUndoSnapshot from '../actions/initializeUndoSnapshot';

export default class Undo extends RoosterUndo {
    constructor(private viewState: EditorViewState) {
        super();
    }

    protected getSnapshotsManager(): UndoSnapshotsService {
        if (!this.undoSnapshots) {
            if (!this.viewState.undoSnapshot) {
                initializeUndoSnapshot(this.viewState);
            }
            this.undoSnapshots = createSnapshotsService(this.viewState.undoSnapshot);
        }
        return this.undoSnapshots;
    }
}

const moveAction = mutatorAction('Undo_Move', (snapshots: Snapshots, delta: number) =>
    moveCurrentSnapsnot(snapshots, delta)
);

const addSnapshotAction = mutatorAction(
    'Undo_AddSnapshot',
    (snapshots: Snapshots, snapshot: string) => addSnapshot(snapshots, snapshot)
);

const clearRedoAction = mutatorAction('Undo_ClearRedo', (snapshots: Snapshots) =>
    clearProceedingSnapshots(snapshots)
);

function createSnapshotsService(snapshots: Snapshots): UndoSnapshotsService {
    return {
        canMove: (delta: number) => canMoveCurrentSnapshot(snapshots, delta),
        move: (delta: number) => {
            moveAction(snapshots, delta);
            return snapshots.snapshots[snapshots.currentIndex];
        },
        addSnapshot: (snapshot: string) => addSnapshotAction(snapshots, snapshot),
        clearRedo: () => clearRedoAction(snapshots),
    };
}
